package com.ives.components.cube3d;

import com.er453r.hxcompo.Component;

import com.ives.utils.math.AxisAngle;

class Cube3D extends Component{
	public function setRotation(x:Float, y:Float, z:Float){
		cube.style.transform = 'translateZ( -600px ) rotateY(${y}deg) rotateX(${x}deg)';
	}

	public function setAxisAngleRotation(axisAngle:AxisAngle){
		cube.style.transform = 'translateZ( -600px ) rotate3d(${axisAngle.axis.x}, ${-axisAngle.axis.z}, ${-axisAngle.axis.y}, ${axisAngle.angle}rad)'; // css axis (x right, y down, z back) vs dicom axis (x right, y front, z up)
	}
}
